var _g, _path, _ellipse, _ellipse2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 64,
    viewBox: "0 0 58 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 5.28595 0 2.92893 1.46447 1.46447C2.92893 0 5.28595 0 10 0H29C37.381 0 41.5715 0 44.9223 1.23617C50.4116 3.26125 54.7387 7.58844 56.7638 13.0777C58 16.4285 58 20.619 58 29C58 37.381 58 41.5715 56.7638 44.9223C54.7387 50.4116 50.4116 54.7387 44.9223 56.7638C41.5715 58 37.381 58 29 58H10C5.28595 58 2.92893 58 1.46447 56.5355C0 55.0711 0 52.714 0 48V10Z",
    fill: "#FFBC0B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8541 45.396C14.7821 45.396 12.4301 44.256 10.7981 41.976C9.19006 39.672 8.38606 36.42 8.38606 32.22C8.38606 29.412 8.74606 27.048 9.46606 25.128C10.2101 23.184 11.2781 21.72 12.6701 20.736C14.0861 19.728 15.8141 19.224 17.8541 19.224C20.9501 19.224 23.3021 20.34 24.9101 22.572C26.5181 24.78 27.3221 27.996 27.3221 32.22C27.3221 35.028 26.9501 37.416 26.2061 39.384C25.4861 41.328 24.4301 42.816 23.0381 43.848C21.6461 44.88 19.9181 45.396 17.8541 45.396ZM17.8541 40.86C19.2461 40.86 20.2781 40.176 20.9501 38.808C21.6221 37.416 21.9581 35.22 21.9581 32.22C21.9581 29.22 21.6221 27.06 20.9501 25.74C20.2781 24.42 19.2461 23.76 17.8541 23.76C16.4621 23.76 15.4301 24.42 14.7581 25.74C14.0861 27.06 13.7501 29.22 13.7501 32.22C13.7501 35.22 14.0861 37.416 14.7581 38.808C15.4301 40.176 16.4621 40.86 17.8541 40.86ZM35.012 45C34.244 45 33.656 44.796 33.248 44.388C32.84 43.98 32.636 43.416 32.636 42.696C32.636 41.952 32.84 41.388 33.248 41.004C33.656 40.62 34.244 40.428 35.012 40.428H38.648V24.192H41.276L36.02 27.396C35.468 27.732 34.952 27.864 34.472 27.792C34.016 27.72 33.62 27.516 33.284 27.18C32.948 26.844 32.72 26.448 32.6 25.992C32.504 25.512 32.552 25.044 32.744 24.588C32.936 24.108 33.296 23.7 33.824 23.364L38.828 20.34C39.332 20.028 39.836 19.776 40.34 19.584C40.868 19.392 41.384 19.296 41.888 19.296C42.608 19.296 43.172 19.488 43.58 19.872C44.012 20.232 44.228 20.796 44.228 21.564V40.428H47.504C48.248 40.428 48.824 40.62 49.232 41.004C49.64 41.388 49.844 41.952 49.844 42.696C49.844 43.44 49.64 44.016 49.232 44.424C48.824 44.808 48.248 45 47.504 45H35.012Z",
    fill: "#FFFEFF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.0227,
    cy: 10.5,
    rx: 7.60186,
    ry: 2.95423,
    transform: "rotate(31.6062 46.0227 10.5)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.59448,
    cy: 51.5551,
    rx: 4.07411,
    ry: 2.17568,
    transform: "rotate(22.2251 6.59448 51.5551)",
    fill: "white",
    fillOpacity: 0.91
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_545",
    x: 0,
    y: 0,
    width: 58,
    height: 63.5172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.51724
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.823215 0 0 0 0 0.598454 0 0 0 0 0.00468252 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_545"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_545",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.d6ef1c2c926137e805cfe1b0fd85f65e.svg";
export { ForwardRef as ReactComponent };